import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgreementRoutes } from './agreement.routes';
import { AgreementListComponent } from './pages/agreement-list/agreement-list.component';
import { CreateNewAgreementComponent } from './pages/create-new-agreement/create-new-agreement.component';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { CanDeactivateGuard } from '@guards/index';
import { InventoryListComponent } from './pages/inventory-list/inventory-list.component';

const ROUTES: Routes = [
    { path: AgreementRoutes.AgreementList, component: AgreementListComponent },
    { path: AgreementRoutes.InventoryList, component: InventoryListComponent },
    { path: AgreementRoutes.Agreement, component: AgreementComponent, canDeactivate: [CanDeactivateGuard] },
    {
        path: AgreementRoutes.CreateNewAgreement,
        component: CreateNewAgreementComponent,
        canDeactivate: [CanDeactivateGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class AgreementRoutingModule {}
